import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '@core/react-query/features/dashboard'
import { dashboardKeys } from '@core/react-query/features/dashboard'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  IObservationStats,
  ObservationStats,
} from '@core/entities/dashboard/observationStats'

const dataTransformer = (observationStats: IObservationStats) =>
  ObservationStats.new(observationStats)

export const useGetDashboardObservationStats = (
  payload: RequestTypes['getDashboardObservationStats'],
  options?: UseQueryOptions<
    IObservationStats,
    RequestErrorType,
    ObservationStats
  >,
) => {
  return useQuery({
    select: dataTransformer,
    ...dashboardKeys.getDashboardObservationStats(payload),
    ...options,
  })
}
